require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-leibal-m-residence.json") })
        }
      }, "path---journal-leibal-m-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-leibal-m-residence!./.cache/json/journal-leibal-m-residence.json
// module id = 509
// module chunks = 231608221292675